<!-- Resize  -->
<div 
    class="resize resize__left" 
    (resize)="onResizeSide($event)" 
    [targetElement]="offcanvasRightAlertView"
    [direction]="AngularResizeElementDirection.LEFT">
</div>

<!-- Header Name -->
<div class="p-2 px-3">
    <div class="d-flex align-items-center justify-content-between" style="gap: 25px;">
        <span class="du-alert-header">Alert</span>
        <!-- Search -->
        <div style="position: relative;width: 100%;">
            <span style="position: absolute;top: 7px;left: 6px;">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11.3335 11.332L14.0002 13.9987" stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
            <input
                type="search"
                class="du-alerts-search"
                placeholder="Search"
                name="patietStatusSearch"
                [(ngModel)]="searchAlertText"
                (ngModelChange)="onFilterTextBoxChanged()"
            />
        </div>
    </div>
</div>

<!-- <hr> -->

<div class="p-2" *ngIf="!loadAlertApi" style="height: calc(100vh - 150px);height: calc(100dvh - 150px);">
  <loading></loading>
</div>

<div *ngIf="loadAlertApi && !isModuleKeyExcludedNewAlerts" style="margin: 5px;">
  <div *ngIf="(alert_notification | searchText: searchAlertText)?.length > 0; else noResults">
      <cdk-virtual-scroll-viewport  class="scrollForAnnotation" itemSize="10" style="overflow-y: auto;height: calc(100vh - 58px);height: calc(100dvh - 58px);font-family: 'Poppins' !important;margin: 4px 4px;">
        <ng-container *cdkVirtualFor="let alt of alert_notification | searchText: searchAlertText; let i = index;trackBy: trackByFnMessage;">
          <div class="d-flex my-3">
            <div class="mr-2">
              <button mat-fab class="alert_dot" [style.background-color]="alt?.unread_flag=='Y' ? '#d11044' : '#c3c2c2'"></button>
            </div>
  
            <div>
              <span class="alert_header">
                <span>{{alt.alert_nm || 'No Name'}}</span>
                <span>{{alt.source_name ? ', ' + alt.source_name : ''}}</span>
                <span>{{alt.sp_location_name ? ', ' + alt.sp_location_name : ''}}</span>
              </span> 
              
              <span class="alert_content">{{alt.alert_desc ||' '}}</span>
              <span class="alert_date">{{ alt.alert_dt ? moment(alt.alert_dt).format('MM.DD.YYYY') : '' }}</span>
            </div>
          </div>
          <hr>
        </ng-container>
      </cdk-virtual-scroll-viewport>
  </div>
</div>

<div *ngIf="loadAlertApi && isModuleKeyExcludedNewAlerts">
  <div *ngIf="alert_notification?.length > 0; else noResults" style="margin: 5px;">
    <cdk-virtual-scroll-viewport class="scrollForAnnotation" itemSize="10" style="height: calc(100dvh - 105px); overflow: auto;">
      <mat-accordion class="mat-accordion-alert-main-expension">
        <mat-expansion-panel
          *cdkVirtualFor="let page of alert_notification; let pageIdx = index; trackBy: trackByFnMessage"
          hideToggle="true"
          #expensionNotes
          class="du-inapp-dashboard-content"
          style="margin: 0 10px 16px !important; border-left-width: 5px;"
          [style.border-left-color]="findBorderColor(page)"
        >    
          <mat-expansion-panel-header>
              
              <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
                  <div class="my-2">
                      <span class="alert_header">{{page.alert_nm + ' - ' + page.source_name}}</span>
                  </div>

                  <div class="d-flex align-items-center" style="gap: 5px;">
                      <span *ngIf="expensionNotes.expanded" class="ml-1">
                          <svg width="8" height="7" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0.0806208 4.9909C0.129399 5.00947 0.18549 4.99899 0.222798 4.96519L3.00001 2.43022L5.77721 4.96494C5.81452 4.99899 5.87113 5.00923 5.91939 4.99089C5.96817 4.97256 6 4.92899 6 4.8809L6 2.73807C6 2.70641 5.98617 2.67616 5.96191 2.65378L3.09235 0.0347655C3.06678 0.0116742 3.03339 2.59349e-07 3 2.62268e-07C2.9666 2.65188e-07 2.93322 0.0116632 2.90765 0.0347655L0.038091 2.65379C0.01383 2.67616 -2.00512e-07 2.70641 -1.97744e-07 2.73807L-1.0412e-08 4.8809C1.23916e-05 4.92899 0.0318422 4.97256 0.0806208 4.9909Z" fill="#8A98AB"/>
                          </svg>
                      </span>
                      <span *ngIf="!expensionNotes.expanded" class="ml-1">
                          <svg width="8" height="7" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.91938 0.0091003C5.8706 -0.00947091 5.81451 0.00100889 5.7772 0.0348143L2.99999 2.56978L0.222786 0.0350598C0.185478 0.00100888 0.128873 -0.00922538 0.0806085 0.00911145C0.0318301 0.0274371 0 0.071008 0 0.119099V2.26193C0 2.29359 0.0138301 2.32384 0.0380909 2.34622L2.90765 4.96523C2.93322 4.98833 2.9666 5 3 5C3.0334 5 3.06678 4.98834 3.09235 4.96523L5.96191 2.34622C5.98617 2.32384 6 2.29359 6 2.26193V0.119099C5.99999 0.071008 5.96816 0.0274371 5.91938 0.0091003Z" fill="#8A98AB"/>
                          </svg>
                      </span>
                  </div>
              </div>
          </mat-expansion-panel-header>
          
          <div *ngFor="let innerGroup of page.groupedAlerts; let i = index; let isLast = last" class="du-global-notes-under-alert" >
            <ng-containter>
                <mat-accordion class="du-global-under-alert">
                    <mat-expansion-panel hideToggle="true" #expensionComments>
                        <mat-expansion-panel-header>
                            <div class="d-flex align-items-center" style="gap: 5px;width: 100%;">
                                <span class="tree-dot" *ngIf="expensionComments.expanded">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="6" cy="6" r="5.5" fill="white" stroke="#8A98AB"/>
                                        <path d="M5.45455 5.45533H3.40909C3.18327 5.45533 3 5.6386 3 5.86442V6.13713C3 6.36295 3.18327 6.54622 3.40909 6.54622H5.45455C5.5 6.54622 5.63782 6.54622 5.86364 6.54622H6.13636C6.36218 6.54622 6.5 6.54622 6.54545 6.54622H8.59091C8.81673 6.54622 9 6.36295 9 6.13713V5.86442C9 5.6386 8.81673 5.45533 8.59091 5.45533H6.54545C6.13636 5.45549 6.36218 5.45508 6.13636 5.45508L5.86364 5.45533C5.63782 5.45533 5.5 5.45533 5.45455 5.45533Z" fill="#8A98AB"/>
                                    </svg>                                        
                                </span>
                                <span class="tree-dot" *ngIf="!expensionComments.expanded">
                                    <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="6" cy="6" r="5.5" fill="white" stroke="#E8EAEE"/>
                                        <path d="M5.45455 3.40909V5.45455H3.40909C3.18327 5.45455 3 5.63782 3 5.86364V6.13636C3 6.36218 3.18327 6.54545 3.40909 6.54545H5.45455V8.59091C5.45455 8.81673 5.63782 9 5.86364 9H6.13636C6.36218 9 6.54545 8.81673 6.54545 8.59091L6.54545 6.54545H8.59091C8.81673 6.54545 9 6.36218 9 6.13636V5.86364C9 5.63782 8.81673 5.45455 8.59091 5.45455H6.54545L6.54545 3.40909C6.54545 3.18327 6.36218 3 6.13636 3L5.86364 3C5.63782 3 5.45455 3.18327 5.45455 3.40909Z" fill="#8A98AB"/>
                                    </svg>                                        
                                </span>

                                <!-- Header -->
                                <div class="d-flex align-items-center" style="gap: 5px;width: 100%;">
                                  <p class="innertGroup-alert-timelabel">{{ innerGroup.label }}</p>
                                  <div class="innertGroup-alert-timeline"></div>
                                </div>
                            </div>
                        </mat-expansion-panel-header>
                        
                        <div class="group-connector"></div>

                        <div *ngFor="let alert of innerGroup.alerts; trackBy: trackByFnMessage">
                          <div class="du-inapp-alerts mb-2" [innerHTML]="alert.safeHtml"></div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </ng-containter>
          </div> 
        </mat-expansion-panel>
      </mat-accordion>
    </cdk-virtual-scroll-viewport>
  </div>
</div>


<ng-template #noResults>
  <div class="p-2 no-results" style="height: calc(100vh - 150px);height: calc(100dvh - 150px);align-content: center;text-align: center;">
    <div class="load-error-handle-du-alert">No data found.</div>
  </div>
</ng-template>

<!-- Resize  -->
<div 
    class="resize resize__bottom--left" 
    (resize)="onResizeSide($event)" 
    [targetElement]="offcanvasRightAlertView"
    [direction]="AngularResizeElementDirection.BOTTOM_LEFT">
</div>